export default __webpack_public_path__ + "static/media/piano1.74f9caa3.png";